module.exports = __webpack_public_path__ + "static/media/Declaration under Section 206.58a7b897.pdf";